import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import { textblocks } from 'seal-ui-components';
import MiddleInfoMessage from '@Components/UI/MiddleInfoMessage';
import ScoreCardItem from '../ScoreCardItem';
import ScoreCardFilters from '../ScoreCardFilters';
import { initialFilterAndSortScoreCard, filterAndSortScoreCard } from '../ScoreCardFilters/filters';
import { ScoreCardListDIV, ScoreCardListWrapper } from './ScoreCardList.style';
import { ScoreCardDetails } from '../ScorecardDetails';

const ScoreCardList = ({ digAppName }) => {
    const {
        data: { scoreCardElementList }
    } = useSelector(state => state.scoreCard.scorecard);

    const { activeFilters, SortFlagsInput, riskFlagsInput } = useSelector(
        state => state.scoreCardFilters
    );

    const numberOfTotalScorecards = scoreCardElementList.length;

    const filteredScoreCardList = Object.keys(activeFilters).length
        ? filterAndSortScoreCard(
              activeFilters,
              scoreCardElementList,
              riskFlagsInput,
              SortFlagsInput
          )
        : initialFilterAndSortScoreCard(scoreCardElementList, riskFlagsInput, SortFlagsInput);

    const [selectedScoreCard, setSelectedScoreCard] = useState({});
    const [isDrawerVisible, setIsDrawerVisible] = useState(false);

    const onClose = () => {
        setIsDrawerVisible(false);
    };

    const openDetails = data => {
        setIsDrawerVisible(true);
        setSelectedScoreCard(data);
    };

    return (
        <>
            {scoreCardElementList && (
                <ScoreCardListDIV>
                    <ScoreCardFilters />
                    <ScoreCardListWrapper data-testid="scorecards_wrapper">
                        {filteredScoreCardList.length > 0 ? (
                            <>
                                {digAppName && (
                                    <textblocks.Heading4 data-testid="digApp-name-scorecards-count">
                                        {`${digAppName} (All: ${numberOfTotalScorecards})`}
                                    </textblocks.Heading4>
                                )}
                                <div data-testid="scorecard-list-container">
                                    {filteredScoreCardList.map((item, idx) => (
                                        <ScoreCardItem
                                            openDetails={openDetails}
                                            key={`ScoreCardItem_${item.uid}`}
                                            rulePosition={idx}
                                            {...item}
                                        />
                                    ))}
                                </div>
                            </>
                        ) : (
                            <MiddleInfoMessage
                                data-testid="empty-filter-message"
                                noposition="true"
                                message="No filter results."
                            />
                        )}
                    </ScoreCardListWrapper>
                    <ScoreCardDetails
                        isOpen={isDrawerVisible}
                        onClose={onClose}
                        data={selectedScoreCard}
                    />
                </ScoreCardListDIV>
            )}
        </>
    );
};

export default React.memo(ScoreCardList);
// ScoreCardList.whyDidYouRender = true;
